import type { SyntheticEvent } from 'react';
import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { Button } from '..';
import { GLOBAL_ICONS } from '../../util/vars';
import { CancelButtonModal } from '../../global';
import { ModalFooter } from '../modal/Modal';
import type { GoalModalProps } from './types';

const DeleteConfirmModal = ({ toggle, toggleConfirm, onSuccess }: GoalModalProps): JSX.Element => {
  const { translate: t } = useI18n();

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    onSuccess?.();
    toggleConfirm(false);
  };

  const handleCancel = () => {
    toggleConfirm(false);
    toggle(true);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={'container space-y-6'}>
        <p>{t('pages.ADMIN.IMPACT_REPORTS.GOAL_MODAL.DELETE_GOAL_CONFIRM')}</p>
      </div>
      <ModalFooter>
        <CancelButtonModal
          align={'start'}
          onClick={handleCancel}
        >
          {t('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.BUTTONS.DISCARD')}
        </CancelButtonModal>
        <Button
          color={'negative'}
          icon={GLOBAL_ICONS.delete}
          isOutline
          onClick={handleSubmit}
        >
          {t('pages.ADMIN.IMPACT_REPORTS.GOAL_MODAL.DELETE_GOAL')}
        </Button>
      </ModalFooter>
    </form>
  );
};

export { DeleteConfirmModal };
